import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IconModule } from "../icon/icon.module";
import { ButtonModule } from "../button/button.module";
import { InputComponent } from "./input.component";
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";
import { RouterModule } from "@angular/router";

@NgModule({
	declarations: [InputComponent],
	imports: [
		CommonModule,
		IconModule,
		ButtonModule,
		LabelModule,
		HelpTextModule,
		StatusModule,
		RouterModule,
		ReactiveFormsModule,
		FormsModule
	],
	exports: [InputComponent]
})
export class InputModule {}
